import { render } from "./DDate.vue?vue&type=template&id=36e6964c&lang=pug"
import script from "./DDate.vue?vue&type=script&lang=js"
export * from "./DDate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__